module.exports = __webpack_public_path__ + "static/media/no-img.eba212f4.svg";